const screeningType = Object.freeze({
    Admin: "externalScreening",
    Internal: "internalScreening"
});

export default screeningType;